<template>
  <v-container fluid class="township-add-page mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="step" class="transparent elevation-0">
          <v-card class="mb-5">
            <v-stepper-header >
              <v-stepper-step :complete="step > 1" step="1">Town Information</v-stepper-step>
              <v-divider></v-divider>
            </v-stepper-header>
          </v-card>

          <v-card>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="6">
                      <v-form>
                        <p class="text-h5">Create New Town</p>
                        <v-text-field
                          class="mb-4"
                          v-model="township.townshipcode"
                          v-bind:error="errorindex == 0"
                          outlined
                          dense
                          placeholder="Town Code"
                          persistent-hint
                          single-line hint="Enter the town Code">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="township.townshipname"
                          v-bind:error="errorindex == 1"
                          outlined
                          dense
                          placeholder="Town Name"
                          persistent-hint
                          single-line hint="Enter the town name">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="township.townshipnameinfo"
                          outlined
                          dense
                          placeholder="Info Text"
                          persistent-hint
                          single-line hint="Enter the info text">
                        </v-text-field>
                        <v-select
                          class="mb-4"
                          :items=townshiptype
                          v-model="township.townshiptype"
                          v-bind:error="errorindex == 2"
                          outlined
                          dense
                          placeholder="Type"
                          persistent-hint
                          single-line hint="Please choose the town type">
                        </v-select>
                          <v-select
                          class="mb-4"
                          :items="regions.map(x => {
                            return {text: x.regionname, value: x._id};
                          })"
                          v-model="township.regionid"
                          v-bind:error="errorindex == 3"
                          outlined
                          dense
                          placeholder="Region"
                          persistent-hint
                          single-line hint="Please choose the region">
                        </v-select>
                          <v-switch
                            v-model="township.townshipstatus"
                            color="primary"
                            v-bind:label="township.townshipstatus"
                            value="Active"
                          ></v-switch>
                        <div class="d-flex justify-end">

                        </div>
                        <div class="d-flex justify-center">
                        <v-btn
                            to="/township/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="createTownship()">
                            Save
                          </v-btn>
                      </div>

                      </v-form>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-card>

        </v-stepper>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      step: 1,
      township: {
        townshipstatus: 'Active'
      },
      townshiptype: ['District', 'Town', 'Township'],
      error: undefined,
      haserror: false,
      errorindex: undefined,
    }
  },

  methods: {
    ...mapActions('Region', ['getRegionsRequest']),
    ...mapActions('Township', ['createTownshipRequest','getTownshipsRequest']),
    checkError(){
      if(!this.township.townshipcode){
        this.haserrors = true;
        this.errorindex = 0;
        return false;
      }
      if(!this.township.townshipname){
        this.haserrors = true;
        this.errorindex = 1;
        return false;
      }
      if(!this.township.townshiptype){
        this.haserrors = true;
        this.errorindex = 2;
        return false;
      }
            if(!this.township.regionid){
        this.haserrors = true;
        this.errorindex = 3;
        return false;
      }
      this.errorindex = -1;
      this.step = 2;
      return true;
    },
    createTownship() {
      if(!this.checkError()) return;
      this.createTownshipRequest(this.township)
      this.getTownshipsRequest()
      router.push('/township/list')
    },
  },
  computed: {
    ...mapState('Region', ['regions']),
    ...mapState('Township', ['isReceiving']),
  },
  mounted () {
    if(this.regions.length==0) this.getRegionsRequest();
  },

}
</script>

<style src="./Add.scss" lang="scss"></style>
